// test typeahead
// import ref from './_state';
import update from './_update';

export default function (ref) {

    let universties = ref.uniNames;

    let substringMatcher = function(strs) {
        return function findMatches(q, cb) {
            let matches, substrRegex;

            // an array that will be populated with substring matches
            matches = [];

            // regex used to determine if a string contains the substring `q`
            substrRegex = new RegExp(q, 'i');

            // iterate through  the pool of strings and for any string that
            // contains the substring `q`, add it to the `matches` array
            jQuery.each(strs, function(i, str) {
                if (substrRegex.test(str)) {
                    matches.push(str);
                }
            });

            cb(matches);
        };
    };

    jQuery('.typeahead').bind('typeahead:select', function(ev, suggestion) {
        // console.log('Selection: ' + suggestion);
        // console.log(ev);

        // console.log(_.indexOf(universties, suggestion));
        ref.activeIndex = _.indexOf(universties, suggestion);
        // console.log('ref.activeIndex', ref.activeIndex);

        // console.log(ref.data[ref.activeIndex]);

        // update charts
        update(ref);


    });

    jQuery('#uni-selection .typeahead').typeahead({
        hint: true,
        highlight: true,
        minLength: 1
    },
    {
        name: 'universties',
        source: substringMatcher(universties)
    });

}



